import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Injector } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, FormControl, ValidationErrors, Validators, ValidatorFn, AbstractControl } from "@angular/forms";

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { Constants } from 'src/app/util/Constants';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../../common/BaseComponent';
import { ProgressService } from 'src/app/service/ProgressService';
import { BpsEmailValidator } from 'src/app/validator/BpsEmailValidator';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';

@Component({
  selector: 'app-email-update',
  templateUrl: './email-update.component.html',
  styles: [
  ]
})
export class EmailUpdateComponent extends BaseComponent implements OnInit {
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  submitted = false;
  restSub: Subscription;
  emailForm: FormGroup;
  appErrorPrefix: string = "bss.api.error";
  user: User;
  resendDisabled: boolean = false;
  showPassword: boolean = false;
  pageMsgRendered: boolean;
  emailAccess: boolean = false;

  constructor(
    injector: Injector,
    public rest: UserService,
    public progressService: ProgressService,
    public fb: FormBuilder) {
    super(injector);
    this.pageMsgRendered = false;
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  ngOnInit(): void {

    const sessionUser = sessionStorage.getItem("user");
    this.user = JSON.parse(sessionUser);

    this.emailAccess = this.user.emailAccess;
    console.log("email access", this.emailAccess);

    if (this.isCertificatelogin) {
      this.router.navigateByUrl('/public/error');
      return;
    }

    this.emailForm = new FormGroup({
      newEmail: new FormControl(null, Validators.compose([Validators.required, PasswordValidator.invalidEmail, BpsEmailValidator.restricted])),
      confirmNewEmail: new FormControl(null, Validators.compose([Validators.required, PasswordValidator.invalidEmail])),
      password: new FormControl(null, Validators.compose([Validators.required])),
      otp: new FormControl(null, Validators.compose([Validators.required, Validators.pattern(Constants.P_NUMBERS_ONLY),
      Validators.minLength(8), Validators.maxLength(8)])),
    }, {
      validators: [compareEmailValidator('newEmail', 'confirmNewEmail')]
    });

    /*this.emailForm = this.fb.group({
      newEmail: ['', [Validators.required, Validators.pattern(Constants.P_EMAIL)]],
      confirmNewEmail: ['', [Validators.required, Validators.pattern(Constants.P_EMAIL)]],
      password: ['', [Validators.required]],
      otp: ['', [Validators.required, Validators.pattern(Constants.P_NUMBERS_ONLY), Validators.minLength(8), Validators.maxLength(8)]],
    },
      { validators: [compareEmailValidator('newEmail', 'confirmNewEmail'), checkCurrentEmailValidator('newEmail', this.user.email)] });
    */

    if (this.emailAccess) {
      this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
        console.log("send-email:" + JSON.stringify(response));
        if (response.result > 0) {
          this.appError = true;
          this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
        } else {
          this.appError = false;
        }
      }, (error) => { this.processError(error) });
    }

  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  onSave() {
    console.log("submitted-val:" + this.emailForm.valid);
    this.submitted = true;
    this.pageMsgRendered = false;
    this.appSuccess = false;
    if (!this.emailAccess) {
      this.emailForm.get('otp').setValue(Constants.DEFAULT_OTP);
    }
    if (this.emailForm.valid) {
      this.isSubmitting = true;
      let user = new User();
      user.newEmail = this.emailForm.get("newEmail").value;
      user.confirmNewEmail = this.emailForm.get("confirmNewEmail").value;
      user.password = this.emailForm.get("password").value;
      user.otp = this.emailForm.get("otp").value;

      this.progressService.open();

      this.restSub = this.rest.updateEmail(user).subscribe(response => {
        console.log("get-data:" + JSON.stringify(response));
        this.isSubmitting = false;
        if (response.result == 1) {
          this.appError = true;
          this.appSuccess = false;
          this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;

          //handle account locked situation
          this.checkIfAccountLocked(response.error_code);
        } else {
          this.appError = false;
          this.clearSession();
          this.router.navigate(['public/emailUpdate/success']);
        }
      }, (error) => {
        this.processError(error);
      },
        () => {
          this.progressService.close();
        });


    } else {
      this.printFormValidationErrors();
    }
  }

  clearSession() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("loginEmail");
    sessionStorage.removeItem("resource_url");
    const redirectUrl = environment.getOamLogoutUri() + "?end_url=" + environment.getLogoutEmailUpdateSuccessUri();
    window.location.href = redirectUrl;
  }

  printFormValidationErrors() {

    let totalErrors = 0;

    Object.keys(this.emailForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.emailForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Control: ' + key + ', [' + keyError + '][', controlErrors[keyError] + ']');
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  onCancel(): void {
    this.router.navigate(['secure/profile']);
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }

  resendOTP() {
    this.resendDisabled = true;
    this.pageMsgRendered = false;
    this.progressService.open();
    this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
      console.log("send-email:" + JSON.stringify(response));
      if (response.result > 0) {
        this.appError = true;
        this.appSuccess = false;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.appSuccessMessage = this.getMessage("bss.user.email.update.otp.sent.success");
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
      }
    );

    setTimeout(() => {
      this.resendDisabled = false;
    }, 60000);
  }
}

function compareEmailValidator(source: string, target: string): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any; } | null => {
    const sourceCtrl = control.get(source);
    const targetCtrl = control.get(target);

    return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value ? { mismatchEmail: true } : null;
  };

}

// function checkCurrentEmailValidator(source: string, target: string): ValidatorFn {

//   return (control: AbstractControl): { [key: string]: any; } | null => {
//     const sourceCtrl = control.get(source);

//     return sourceCtrl && target && sourceCtrl.value === target ? { containsCurrentEmail: true } : null;
//   };

// }